import { MemberAccountStatusIdEnum } from '../../transactions/enum/member-account-status-id.enum';

export const AccountStatusPrimaryColors: Record<MemberAccountStatusIdEnum, string> = {
  [MemberAccountStatusIdEnum.Pending]: '#CC7212',
  [MemberAccountStatusIdEnum.Active]: '#0D5D4B',
  [MemberAccountStatusIdEnum.Inactive]: '#666666',
  [MemberAccountStatusIdEnum.Struck]: '#A5291C',
  [MemberAccountStatusIdEnum.Suspended]: '#A5291C'
};

export const AccountStatusSecondaryColors: Record<MemberAccountStatusIdEnum, string> = {
  [MemberAccountStatusIdEnum.Pending]: '#FCF6EB',
  [MemberAccountStatusIdEnum.Active]: '#E8F3F1',
  [MemberAccountStatusIdEnum.Inactive]: '#F7F7F7',
  [MemberAccountStatusIdEnum.Struck]: '#FCEBEA',
  [MemberAccountStatusIdEnum.Suspended]: '#FCEBEA'
};
